import React, { useCallback } from 'react';
// redux
import { useDispatch } from 'react-redux';
import * as actionGlobal from '@redux/global/actions';
// components
import { CustomNotification, FolderSelector } from 'common/components';
import AddToFolderActions from 'common/components/grid-view/components/add-to-folder/AddToFolderActions';
// hooks
import {
  useHandleAddSearchProductToFolder,
  useAddSearchProductToFolder,
} from 'hooks/folders/useAddSearchProductToFolder';

import './AddSearchProductToFolder.less';

const AddSearchProductToFolder = ({ paramsAddSearchProductToFolder }) => {
  const dispatch = useDispatch();

  const {
    folderSelectorRef,
    currentFolderId,
    selectedFolder,
    onSelectFolder,
    onBreadcrumbChange,
    onExpandFolder,
  } = useHandleAddSearchProductToFolder();

  const addSearchProductToFolder = useAddSearchProductToFolder();

  const onCloseAddToFolder = () => {
    dispatch(actionGlobal.toggleAddSearchProductToFolder());
  };

  const handleSuccessCallback = (folder) => {
    const newParams = {
      ...paramsAddSearchProductToFolder,
      filters: [
        ...paramsAddSearchProductToFolder.filters,
        ...(paramsAddSearchProductToFolder.filterFromAgGrid || []),
      ],
    };
    const params = {
      folderId: folder?.id,
      ...newParams,
    };

    addSearchProductToFolder.mutate(params, {
      onSuccess: (res) => {
        if (res?.isSuccess) {
          CustomNotification.success(
            res?.message ?? `Add to Folder successfully`
          );
          onCloseAddToFolder();
        } else {
          CustomNotification.error(res?.message ?? 'Cannot add to folder');
        }
      },
      onError: () => {
        CustomNotification.error('Cannot add to folder');
      },
    });
  };

  const disableSubmitButton = !selectedFolder || selectedFolder?.id === 'home';
  const selectedFolderId =
    selectedFolder?.id !== 'home' ? selectedFolder?.id : null;

  return (
    <div className='add-search-product-to-folder'>
      <div className='add-search-product-to-folder_title'>
        <h4>Add search results to folder</h4>
      </div>

      <div className='add-search-product-to-folder_list'>
        <FolderSelector
          ref={folderSelectorRef}
          loading={addSearchProductToFolder.isLoading}
          onSelectFolder={onSelectFolder}
          onBreadcrumbChange={onBreadcrumbChange}
          onExpandFolder={onExpandFolder}
          disabledDragDrop={true}
        />
      </div>

      <div className='add-search-product-to-folder_footer'>
        <AddToFolderActions
          parentId={selectedFolderId || currentFolderId}
          currentFolderId={currentFolderId}
          onCancel={onCloseAddToFolder}
          successCallback={handleSuccessCallback}
          disableSubmitButton={disableSubmitButton}
          onSubmit={() => handleSuccessCallback(selectedFolder)}
          loading={addSearchProductToFolder.isLoading}
        />
      </div>
    </div>
  );
};

export default AddSearchProductToFolder;
